export enum MaintenancePageNameValue {
    USA = 'usa',
    EUROPA = 'europa'
}

export class MaintenancePageName {

    private readonly _value: MaintenancePageNameValue;

    public constructor(value: MaintenancePageNameValue) {
        this.ensureIsNotUndefined(value);
        this._value = value;
    }

    private ensureIsNotUndefined(value: string): void {
        if (value === undefined) {
            throw new Error('MaintenancePageName cannot be undefined');
        }
    }

    public get value(): MaintenancePageNameValue {
        return this._value;
    }

}
